import React from "react";
import "./Footer.css";
import {
  Link,
  Stack,
  Typography,
} from "@mui/joy";

const Footer = () => {

  return (
    <Stack
      padding={4}
      spacing={2}
      sx={(theme) => ({
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        flexGrow: 1,
        backgroundColor: theme.vars.palette.primary[200],
      })}
      component="footer"
    >
      <Stack direction={"column"} spacing={2}>
        <Link
          href="/"
          level="body-sm"
          variant="plain"
          className="logo"
          sx={(theme) => ({
            color: theme.vars.palette.primary[600],
          })}
        >
          Home
        </Link>
        <Link
          href="/bills"
          level="body-sm"
          variant="plain"
          sx={(theme) => ({
            color: theme.vars.palette.primary[600],
          })}
          className="logo"
        >
          Bills & Legislation
        </Link>
        <Link
          href="/legislators"
          level="body-sm"
          variant="plain"
          sx={(theme) => ({
            color: theme.vars.palette.primary[600],
          })}
          className="logo"
        >
          Legislators
        </Link>
        <Link
          href="/resources"
          level="body-sm"
          variant="plain"
          sx={(theme) => ({
            color: theme.vars.palette.primary[600],
          })}
          className="logo"
        >
          Resources
        </Link>
      </Stack>
      <Stack direction={"column"} sx={{width: '50%'}}>
        <Typography
          href="/"
          level="body-sm"
          variant="plain"
        >
          CivicEnage exists to help everyone learn about upcoming bills and
          legislation, both on a federal and state level, and urge people to
          take action on issues they care about by offering a simple email
          template to send to their representative.
        </Typography>
        <Typography
          href="/"
          level="body-sm"
          variant="plain"
        >
          CivicEngage.me is <b>not</b> a government website.
        </Typography>
      </Stack>
      <Stack direction={"column"}>
        <Link
          href="https://www.buymeacoffee.com/martinuzzif"
          level="body-sm"
          variant="solid"
          underline="hover"
          color="primary"
        >
          &#9749; Buy me a coffee
        </Link>
        <Typography
          level="body-sm"
          variant="plain"
        >
          &#169; Jordan Martinuzzi 2025
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Footer;
